import hyraxios from './hyraxios'

// 用户登录
export function login(mobile, password) {
  return hyraxios.post('/apis/server/user/login', {
    mobile,
    password,
  })
}
export function workexp() {
  return hyraxios.post('/apis/server/index/workexp', {

  })
}

//基础资料
export function userInfo(info) {
  return hyraxios.post('/apis/user/findById', {
    info,
  })
}
//修改基础资料
export function userUpdate(info) {
  return hyraxios.post('/apis/user/update', {
    info,
  })
}
//卡列表-个人中心
export function cardList(info) {
  return hyraxios.post('/apis/user/card/cardloginlist', {
    info,
  })
}
//卡登录-绑定卡(输入账号密码)
export function bindCard(info) {
  return hyraxios.post('/apis/user/card/cardBind', {
    info,
  })
}
//卡登录-获取用户id
export function findById(info) {
  return hyraxios.post('/apis/user/findById', {
    info,
  })
}
//卡登录-绑定卡(二维码扫码)
export function cardBindScanLinks(info) {
  return hyraxios.post('/apis/user/card/cardBindScanLinks', {
    info,
  })
}
export function cardStatus(info) {
  return hyraxios.post('/apis/user/card/cardStatus', {
    info,
  })
}

//卡登录-失效卡
export function cardInValid(info) {
  return hyraxios.post('/apis/user/card/cardInValid', {
    info,
  })
}

//卡登录-失效卡
export function invalidCardList(info) {
  return hyraxios.post('/apis/user/card/invalidCardList', {
    info,
  })
}

//卡登录-有效卡
export function cardValid(info) {
  return hyraxios.post('/apis/user/card/cardValid', {
    info,
  })
}
//实名制添加-观影人添加
export function watchUserAdd(info) {
  return hyraxios.post('/apis/user/authentication/add', {
    info
  })
}
//实名制列表-删除观影人
export function watchUserDel(info) {
  return hyraxios.post('/apis/user/authentication/delete', {
    info,
  })
}
//实名制列表-观影人列表
export function watchUserList(info) {
  return hyraxios.post('/apis/user/authentication/findbyuserid', {
    info,
  })
}
//基础资料 接口暂无
export function baseInfo(userId) {
  return hyraxios.post('/apis/user/authentication/findbyid', {
  })
}
//收获地址-列表
export function addressList(userId) {
  return hyraxios.post('/apis/user/address/findByAll', {
  })
}
//收货地址-添加
export function addressAdd(info) {
  return hyraxios.post('/apis/user/address/add', {
  })
}
//获取图片验证码  不带 sign 参数
// export function getCode(info) {
//   return hyraxios.get('/apis/code/image', {
//     info
//   })
// }

//获取图片验证码 增加 sign 传参
export function getCode(sign, info) {
  return hyraxios.get('/apis/code/image/?sign=' + sign, { info })
}

//获取省市县代码
export function getAddressCode(info) {
  return hyraxios.post('/apis/sys/address/findbycode', {
    info
  })
}
//二维码-卡列表
export function cardqrcodeList(info) {
  return hyraxios.post('/apis/user/card/cardqrcodelist', {
    info
  })
}
//二维码-卡信息
export function cardqrcode(info) {
  return hyraxios.post('/apis/user/card/cardqrcode', {
    info
  })
}

//微信公众号二维码-卡列表
export function cardqrcodelistforwxcode(info) {
  return hyraxios.post('/apis/user/card/cardqrcodelistforwxcode', {
    info
  })
}

//二维码-二维码消费卡信息
export function cardgetofflineqrinfo(info) {
  return hyraxios.post('/apis/user/card/cardgetofflineqrinfo', {
    info
  })
}


//获取微信openid
export function weixinweblogin(info) {
  return hyraxios.post('/apis/weixinweb/login', {
    info
  })
}

//提货券 - 卡查询 （账号密码）
export function giftVoucherCardCardQuery(info) {
  return hyraxios.post('/apis/user/card/giftVoucherCardCardQuery', {
    info,
  })
}
//提货券 - 卡查询 （二维码）
export function giftVoucherCardQueryByScan(info) {
  return hyraxios.post('/apis/user/card/giftVoucherCardQueryByScan', {
    info,
  })
}

//网站-获取城市appId
export function getwebAppId(info) {
  return hyraxios.post('/apis/weixinweb/getAppId', {
    info,
  })
}

//网站-code登录
export function getwebLogin(info) {
  return hyraxios.post('/apis/weixinweb/webLogin', {
    info,
  })
}

//网站-code登录
export function getmobileLogin(info) {
  return hyraxios.post('/apis/weixinweb/mobileLogin', {
    info,
  })
}

//网站-获取sessionKey
export function getwebLoginUpdateKey(info) {
  return hyraxios.post('/apis/weixinweb/webLoginUpdateKey', {
    info,
  })
}

//网站-获取卡登录列表
export function getcardWebLoginList(info) {
  return hyraxios.post('/apis/user/card/cardWebLoginList', {
    info,
  })
}

//网站-卡绑定列表
export function webBindCard(info) {
  return hyraxios.post('/apis/user/card/webCardBind', {
    info,
  })
}

//网站-电影plus卡绑定列表
export function webCardBindPLUS(info) {
  return hyraxios.post('/apis/user/card/webCardBindPLUS', {
    info,
  })
}

//网站-用户信息
export function webuserUpdate(info) {
  return hyraxios.post('/apis/user/webUpdate', {
    info,
  })
}

//网站-有效卡列表
export function webCardValid(info) {
  return hyraxios.post('/apis/user/card/webCardValid', {
    info,
  })
}

//网站-无效卡列表
export function webCardInValid(info) {
  return hyraxios.post('/apis/user/card/webCardInValid', {
    info,
  })
}

//webCode登录
export function webLogin(info) {
  return hyraxios.post('/apis/weixinweb/login', {
    info,
  })
}


// 短信验证码
export function getMsg(phone) {
  return hyraxios.get('/apis/code/message/?phone=' + phone)
}

// 绑定手机号
export function bindPhone(info) {
  return hyraxios.post('/apis/weixinweb/updateMobileByUserId2', {
    info,
  })
}

// 美团
export function mtCardLogin(info) {
  return hyraxios.post('/apis/user/card/cardLoginListMeiTuan', {
    info,
  })
}


//新1--收货地址-添加 --------------
export function addAddress(info) {
  return hyraxios.post('/apis/user/addressSession/add', {
    info
  })
}

// 2 收货地址列表
export function findByAll(info) {
  return hyraxios.post('/apis/user/addressSession/findByAll', {
    info
  })
}

// 3 删除用户地址
export function delAddress(info) {
  return hyraxios.post('/apis/user/addressSession/delete', {
    info
  })
}

// 4 设置当前地址为默认收货地址
export function setDefault(info) {
  return hyraxios.post('/apis/user/addressSession/setDefault', {
    info
  })
}

// 5 修改用户收货地址
export function updateAddress(info) {
  return hyraxios.post('/apis/user/addressSession/update', {
    info
  })
}

// 6 获取签名
export function getIntegralsign(info) {
  return hyraxios.post('/apis/applets/user/getsign', {
    info
  })
}


// 6 获取积分卡
export function getIntgerCard(info) {
  return hyraxios.post('/apis/user/card/getIntgerCard', {
    info
  })
}


// 7 获取调取微信公众号配置信息
export function getSign(url) {
  return hyraxios.get('/apis/weixinweb/getSign/?url=' + url)
}

// 8 获得地址版本
export function getVersionAddress(info) {
  return hyraxios.get('/apis/sys/address/getVersionAddress')
}


// 9 获得地址4级数据集
export function getAddressByRedis() {
  return hyraxios.post('/apis/sys/address/getAddressByRedis')
}

//9 获得地址4级数据集
export function getAddressList(parentId) {
  return hyraxios.post('/apis/sys/address/getAddressList/?parentId=' + parentId)
}

// ==============

// ====  1个人中心部分接口 ====

// 10 获得广告轮播
export function getAdvertisFront() {
  return hyraxios.post('/apis/ucAdvertis/getAdvertisFront')
}

// 11 获得多功能图标
export function getMulFront(info) {
  return hyraxios.post('/apis/ucAdvertis/mulFunctionFront', { info })
}


// 12 渠道入口地址
export function getOtherFront(query, info) {
  return hyraxios.post(`/apis/ucAdvertis/otherBusinessFront?sign=${query.sign}&type=${query.type}`, { info })
}

// 1==============



// WEBPACK FOOTER //
// ./src/api/user.js